import { DealLostModalProps } from './DealLostModal';
import { openModal } from '@core/components/ModalStack';

export async function openDealLostModal(props: DealLostModalProps) {
  const { DealLostModal } = await import('./DealLostModal');
  openModal(DealLostModal, props);
}
